import { motion } from "framer-motion";

type Props = {
  intensity: number;
  onTap?: () => void;
  size?: number;
  label?: string;
};

/**
 * 鈴 SVG (placeholder)。
 * intensity (0..1) に応じて揺れの振幅と紐の動きが大きくなる。
 */
export function Bell({ intensity, onTap, size = 180, label }: Props) {
  const amp = 6 + intensity * 18;
  const speed = 1.1 - intensity * 0.7;

  return (
    <button
      type="button"
      onClick={onTap}
      className="relative inline-flex flex-col items-center select-none"
      aria-label={label ?? "Bell"}
    >
      {/* 紐 */}
      <motion.div
        animate={{ rotate: [-2, 2, -2] }}
        transition={{ duration: speed, repeat: Infinity, ease: "easeInOut" }}
        className="origin-top"
        style={{ width: 4, height: size * 0.4, background: "linear-gradient(to bottom, #6b1024, #c43a55)" }}
      />
      {/* 鈴本体 */}
      <motion.svg
        viewBox="0 0 100 100"
        width={size * 0.55}
        height={size * 0.55}
        animate={{
          rotate: [-amp, amp, -amp],
          scale: [1, 1 + intensity * 0.06, 1],
        }}
        transition={{ duration: speed, repeat: Infinity, ease: "easeInOut" }}
        style={{
          marginTop: -4,
          filter: `drop-shadow(0 0 ${12 + intensity * 24}px rgba(201,169,97,${0.4 + intensity * 0.5}))`,
        }}
      >
        <defs>
          <radialGradient id="bell-gold" cx="0.35" cy="0.3" r="0.8">
            <stop offset="0%" stopColor="#fff5d6" />
            <stop offset="40%" stopColor="#e6cc88" />
            <stop offset="100%" stopColor="#8a6b2c" />
          </radialGradient>
        </defs>
        <ellipse cx="50" cy="50" rx="36" ry="32" fill="url(#bell-gold)" />
        <rect x="46" y="20" width="8" height="12" rx="2" fill="#6b4c1a" />
        <ellipse cx="50" cy="68" rx="22" ry="6" fill="#1a1a1a" opacity="0.25" />
        {/* 開口 */}
        <ellipse cx="50" cy="78" rx="28" ry="4" fill="#6b4c1a" />
      </motion.svg>
      {/* 振動波紋 */}
      {intensity > 0.05 && (
        <motion.div
          aria-hidden
          className="absolute top-[40%] left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full"
          initial={{ scale: 0, opacity: 0.5 }}
          animate={{ scale: 2.4, opacity: 0 }}
          transition={{ duration: 1.2, repeat: Infinity }}
          style={{
            width: size * 0.55,
            height: size * 0.55,
            border: "2px solid rgba(201,169,97,0.6)",
          }}
        />
      )}
    </button>
  );
}
